import { render, staticRenderFns } from "./EventMessages.vue?vue&type=template&id=3583b43c&"
import script from "./EventMessages.vue?vue&type=script&lang=js&"
export * from "./EventMessages.vue?vue&type=script&lang=js&"
import style0 from "./EventMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports